<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>

        <BreadcrumbItem to="/appcenter?sgnav=ptsz">平台设置</BreadcrumbItem>
        <BreadcrumbItem to="">用户管理</BreadcrumbItem>

      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.name" placeholder="" />
      </Col>

      <Col span='1'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>

      <ul class='conheadRight'>
        <i-button type="error" @click='getId(-1)'>新建账号</i-button>
      </ul>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>
    <Modal v-model="edituser" title='用户新增/修改' width='700px' :mask-closable='false'>
      <Form :model="formItem" :label-width="80">
        <section id='con' @click='hideInput'>
          <section class='conleft'>
            <Form-item label="权限栏目" prop='title'>
              <selftree :treedata='lanmu' :treekey="treekey" @click.stop='' :ischeck='true' :hideInputNum='hideInputNum'
                @changeClass='changeRenke'></selftree>
            </Form-item>
          </section>
          <section class='conRight'>
            <Form-item label="用户名" prop="title">
              <Input v-model="formItem.username" placeholder=""></Input>
            </Form-item>
            <Form-item label="密码" v-show='formItem.guid == ""'>
              <Input v-model="formItem.password" placeholder=""></Input>

            </Form-item>
            <Form-item label="昵称">
              <Input v-model="formItem.name" placeholder=""></Input>
            </Form-item>
            <Form-item label="手机号">
              <Input v-model="formItem.phone" placeholder=""></Input>
            </Form-item>
            <Form-item label="角色">
              <!-- <checkbox-group v-model="mewsto">
                                <checkbox v-for="item in newstoData" :label='item.id' :key='item.id' >{{item.name}}</checkbox>
                              </checkbox-group> -->
              <RadioGroup v-model="mewsto">
                <!-- <Radio label=''>总管理员</Radio > -->
                <Radio v-for='item in newstoData' :label='item.id' :key='item.id'>{{ item.name }}</Radio>
              </RadioGroup>
            </Form-item>
            <Form-item label="是否超管">
              <i-switch v-model="formItem.isadmin" size="large">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </Form-item>
          </section>
        </section>
      </Form>

      <div slot="footer" style='position:relative;clear:both'>

        <Button type="error" @click='removeItem' class='remove' icon="md-trash"
          v-if='this.formItem.id != ""'>删除</Button>
        <Button type="error" @click='resetPwd' icon="md-pricetag" class='resetBtn'>重置密码</Button>
        <Button type="default" @click='edituser = false' icon="md-close">取消</Button>
        <Button type="info" @click='postNews(true)' icon="md-checkmark-circle-outline">保存</Button>
      </div>

    </Modal>



  </section>
</template>

<script>

import tablePage from './tablePage'
import selftree from './inputTreeuser'
import util from '../utils/index.js'
export default {
  name: 'sysUserlist',
  components: {
    tablePage,
    selftree,
  },
  data () {
    return {
      edituser: false,
      lanmu: [],
      mewsto: '',
      newstoData: [],
      isnewModal: false,
      treekey: -1,
      checkSchool: [],
      userDrawer: false,
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      hideInputNum: -1,
      queryData: ['webUser/dataList',
        [{
          title: '姓名',
          key: '',
          width: 240,
          ellipsis: true,
          render: (h, params) => {
            var pic = params.row.face ? params.row.face : ''
            var _firstLetter = params.row.name.substr(0, 1)
            if (params.row.face) {
              return h('viewer', [
                h('img', {
                  style: {//设置样式
                    display: 'inline-block',
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    textAlign: 'center',
                    lineHeight: '30px',
                    position: 'absolute',
                  },
                  attrs: {//设置属性
                    src: params.row.face
                  }
                }),
                h('span', {
                  style: {
                    fontWeight: 'bold',

                    height: '30px',
                    paddingLeft: '45px',
                    lineHeight: '30px',
                  },
                }, params.row.name)
              ]
              )
            } else {
              return h('div', [
                h('span', {

                  style: {
                    display: 'inline-block',
                    width: '30px',
                    height: '30px',
                    background: 'rgba(237,76,120,.1)',
                    borderRadius: '50%',
                    textAlign: 'center',
                    lineHeight: '30px',
                    color: '#ed4c78',
                    position: 'absolute',

                  },
                }, _firstLetter),
                h('span', {
                  style: {
                    fontWeight: 'bold',

                    height: '30px',
                    paddingLeft: '45px',
                    lineHeight: '30px',
                  },
                }, params.row.name)
              ])
            }
          }
        },
        // {
        // 	title: '是否管理员',
        // 	key: '',
        // 	align: 'center',
        // 	ellipsis:true,
        // 	width:200,
        // 	render: (h, params) => {

        // 		return h('span', decodeURI(params.row.isadmin))
        // 	}
        // },
        {
          title: '账号',
          key: 'username',
          align: 'center',
          ellipsis: true,
          width: 200,
          render: (h, params) => {

            return h('span', decodeURI(params.row.username))
          }
        },
        {
          title: '手机号',
          key: 'phone',
          align: 'center',
          ellipsis: true,
          width: 200,
        },
        {
          title: '是否超管',
          key: 'isadmin',
          align: 'center',
          ellipsis: true,
          width: 200,
          render: (h, params) => {
            var isadmin = params.row.isadmin == 1 ? '是' : ''
            return h('span', isadmin)
          }
        },
        {
          title: '添加时间',
          key: 'addtime',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '60px',
                  height: '25px',
                  background: '#2db7f5',
                  borderRadius: '6px',
                  textAlign: 'center',
                  lineHeight: '25px',
                  color: '#fff',
                  fontSize: '12px',
                  cursor: 'pointer',
                  userSelect: 'none'
                },
                on: {
                  click: () => {


                    this.curStuInfo = params.row
                    this.getId(params.row.guid)
                    // user.isPrincipal = user.isPrincipal == 1 ? true : false
                    // user.state = user.state == 1 ? true : false


                  }
                }
              }, '编辑')
            ])
            // <span class='do' @click="show(index,row)">编辑</span>
          }
        }

        ]
      ],
      searchParam: {
        name: '',
      },
      issearch: -1,
      signData: [],
      lcdData: [],
      partData: [],
      roleData: [],
      schoolData: [],
      kmData: [],
      curUser: {},
      inputtext: '',
      curStuInfo: {},
      formItem: {
        selRoles: '',
        username: '',
        password: '',
        name: '',
        itemids: '',
        state: false,
        isadmin: false,
        phone: '',
      },
    }
  },
  props: {
    fromheadschoolid: {
      default: -1
    }
  },
  watch: {
    fromheadschoolid (newval, oldval) {
      //console.log(newval,oldval)
      this.curSchoolid = newval
      this.queryData[0] = 'webUser/dataList?isPrincipal=-1&schoolid=' + newval
      this.reloadTable()
    },
  },
  mounted () {
    var that = this
    var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.curSchoolid = localStorage.getItem('curSchoolid')
    this.queryData[0] = 'webUser/dataList'
    this.getRolelist()
  },
  methods: {
    resetPwd () {
      //console.log(this.curStuInfo)

      var that = this
      var param = {
        username: that.curStuInfo.username,
        guid: that.curStuInfo.guid,
      }
      this.axios.post('webUser/resetpwd', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.edituser = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    getId (id) {
      var that = this
      this.formItem = {
        selRoles: '',
        username: '',
        password: '',
        name: '',
        itemids: '',
        state: true,
        guid: '',
        isadmin: false,
      }
      this.lanmu = []
      this.mewsto = -1
      this.edituser = true
      that.treekey = Math.random()
      if (id != -1) {
        this.isnewModal = false
        this.axios.get('webUser/getId', { params: { guid: id } }).then(res => {
          //console.log(res)
          that.formItem.name = res.data.name
          that.formItem.username = res.data.username
          that.formItem.password = res.data.password
          that.formItem.guid = res.data.guid
          that.formItem.phone = res.data.phone || ''
          that.formItem.isadmin = res.data.isadmin == 1 ? true : false
          that.mewsto = res.data.roleIds[0]
          // that.formData.state = res.data.state ? true :false
          var itemid = res.data.itemids.split(',')

          var lanmu = []
          itemid.map(function (val, index) {
            var _val = val.split('_')
            lanmu.push(_val[_val.length - 1])
          })
          that.formItem.itemids = that.lanmu = lanmu
          //console.log(lanmu)

          that.treekey = Math.random()
        })
      }

    },
    postNews () {
      var that = this

      var param = {
        selRoles: this.mewsto,
        username: this.formItem.username,
        password: this.formItem.password,
        name: this.formItem.name,
        guid: this.formItem.guid,
        itemids: this.formItem.itemids.join(','),
        phone: this.formItem.phone,
        isadmin: this.formItem.isadmin ? 1 : 0
      }
      //console.log(param,'parm')

      this.axios.post('webUser/save', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.edituser = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    getRolelist () {
      var that = this
      this.axios.get('sysRole/dataList', { params: {} }).then(res => {
        //console.log(res,'res')
        that.newstoData = res.data
      })
    },
    exportData () {
      var param = {

        name: this.searchParam.name,
        length: -1
      }

      var tHeader = ['姓名', '账号', '任课班级', '班主任']
      var filterVal = ['name', 'username', 'classname', 'headerClassName']
      util.exportExcel('webUser/dataList?isPrincipal=-1', param, '教师账号', tHeader, filterVal)


    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid) {
      //console.log(guid, 'guid', this.formData[0][0])
      this.reloadTmep = Math.random()
      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      this.formData[0][0] = this.formData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
    },
    reloadTable () {
      this.issearch = Math.random()
    },
    hideInput (e) {

      this.hideInputNum = Math.random()
    },

    getSingleInfo (id) {
      var that = this
      this.edituser = true

      //console.log(id)
      if (id != -1) {
        this.isnewModal = false
        this.axios.get('webUser/getId', { params: { id: id } }).then(res => {
          //console.log(res)
          that.treekey = Math.random()
        })
      } else {
        this.isnewModal = true
        this.curUser = {
          selRoles: '',
          username: '',
          password: '',
          name: '',
          itemids: '',
        }
        that.treekey = Math.random()
      }

    },
    resetItem () {
      var that = this
      this.curUser['headteacher'] = []
      that.treekey = Math.random()
    },
    removeItem () {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          //console.log(that.curStuInfo)
          var param = {
            id: that.curStuInfo.guid
          }

          that.axios.post('webUser/delete', param).then(res => {
            if (res.success) {
              that.$Message.info(res.msg)
              that.reloadTable()
              that.edituser = false
            } else {
              that.$Message.error(res.msg)
            }
          })
        },
        onCancel: () => {

        }
      });
    },
    changeRenke (val) {
      //console.log(val)
      this.formItem.itemids = val['classid'].split(',')
    },
    changeClass (val) {
      //console.log(val)
      this.curUser.pushclass = val['onlyClassid'].split(",")
      //this.curUser.pushclass =val['onlyClassid'].split(",")
    },
    changehead (val) {
      //console.log(val)
      this.curUser.headteacher = val['onlyClassid'].split(",")
      // this.curUser.headteacher = val['onlyClassid'].split(",")
    },
    getDepart (id) {
      var name = ''
      var partData = this.partData
      for (var i = 0; i < partData.length; i++) {
        for (var j = 0; j < id.length; j++) {
          if (partData[i]['id'] == id[j]) {
            name += partData[i]['name'] + ','
          }
        }
      }
      //console.log(id,partData)
      return name.substring(0, name.length - 1)
    },
    getRole (id) {
      var name = ''
      var partData = this.roleData
      for (var i = 0; i < partData.length; i++) {
        for (var j = 0; j < id.length; j++) {
          if (partData[i]['id'] == id[j]) {
            name += partData[i]['name'] + ','
          }
        }
      }

      return name.substring(0, name.length - 1)
    },
    getClassName (tree, ids) {

      for (var i = 0; i < tree.length; i++) {
        for (var j = 0; j < ids.length; j++) {
          if (tree[i]['id'] == ids[j]) {
            this.inputtext += tree[i]['name'] + ','
          }
        }
        if (tree[i]['children'].length > 0) {
          this.getClassName(tree[i]['children'], ids)
        }
      }
    },
    getHeadTeach (id) {
      var data = this.schoolData
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i]['children'].length; j++) {
          if (data[i]['children'][j]['id'] == id) {
            return data[i]['id']
          }
        }

      }
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;

}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  margin-right: 20px;
}

#userStyle li {
  display: flex;
  justify-content: flex-start;
  list-style: none
}

#userStyle li h6 {
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  margin-top: -2px;
}

#userStyle .avatarinfo p {
  font-size: 12px;
  position: relative;
  top: 2px;
}

#userStyle .avatarinfo .ivu-input-wrapper {}

#userStyle ul {
  margin-bottom: 30px;
}

.selfRow {
  overflow: visible;
  width: 100%;
}

.selfRow .nor:first-of-type {
  float: left;
  width: 48%
}

.selfRow .nor:last-of-type {
  float: right;
  width: 48%
}

.selfswitch {
  width: 50%;
  box-sizing: border-box;
  padding-left: 6px;
  float: left;
}

#userStyle {
  margin: 0px 10px;
  padding-bottom: 20px;
}

.remove {
  float: left;
  margin-left: 0px;
}

.ivu-drawer-body {
  padding-bottom: 100px;
}

.drawFooter {
  width: 560px;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  overflow: hidden;
}

.resetBtn {
  float: left;
  margin-left: 20px;
  background-color: #ffad33 !important;
  border-color: #ffad33 !important;
  box-shadow: 0 2px 6px 0 rgba(255, 173, 51, .5) !important
}

/* #con{
    display:flex;
    justify-content: space-between;
  } */
</style>
